import React from "react";
import PropTypes from "prop-types";

import { assertOneOf } from "../../internal/contracts";
import { useThemeA } from "../../internal/ThemeAContext";

const WIDTHS = ["standard", "wide", "full"];
const WIDTH_CLASSES = {
  standard: "akv:max-w-[72rem]",
  wide: "akv:max-w-[94rem]",
  full: "akv:max-w-none",
};
const PAGE_CLASSES = [
  "akv:box-border akv:mx-auto akv:w-full akv:p-6",
  "akv:font-ak-body akv:text-ak-text",
  "akv:max-[48rem]:p-3",
  // Entrée de vue (charte motion) : one-shot au montage, coupé par reduced-motion.
  // `backwards` et non `both` : l'état final d'ak-rise EST l'état naturel, donc
  // rien à retenir après la fin. Avec `both`, l'animation de `transform` restait
  // « en vigueur » pour toujours et faisait de Page le bloc conteneur de tout
  // descendant `position: fixed` (bandeau de filtres des analyses calé sur Page
  // — vide sous l'en-tête, gouttière à droite — au lieu de la fenêtre).
  "akv:animate-[ak-rise_var(--ak-v2-motion-entrance)_var(--ak-v2-motion-easing)_backwards]",
  "akv:motion-reduce:animate-none",
].join(" ");

// Décision 2026-08-25 : la Chronologie est la référence de conteneur — pleine
// largeur par défaut ; "wide"/"standard" restent des exceptions à justifier.
export default function Page({ children, width = "full", ariaLabel }) {
  useThemeA("Page");
  assertOneOf("Page", "width", width, WIDTHS);

  return (
    // WelfareShellV2 owns the document's single <main> landmark. Page stays
    // semantic when labelled without nesting a second main inside the shell.
    <section
      className={`${PAGE_CLASSES} ${WIDTH_CLASSES[width]}`}
      aria-label={ariaLabel}
      data-ak-v2-component="page"
      data-ak-v2-page-identity="permanent"
    >
      {children}
    </section>
  );
}

Page.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  width: PropTypes.oneOf(WIDTHS),
};
